export const STORE_USER_TYPE = 'STORE_USER_TYPE';

export const STORE_TRANSACTION_BONDS = 'STORE_TRANSACTION_BONDS';

export const STORE_PERMISSION_USER_FOR_FINANCIAL_FILE = 'STORE_PERMISSION_USER_FOR_FINANCIAL_FILE'
